import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { useUrlPagination } from '../../shared/hooks/useUrlPagination.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';
import { EmptyState } from '../../shared/ui/EmptyState';
import { Factory, Plus } from 'lucide-react';

const PAGE_SIZE = 5;

const IndustriesPage = () => {
  const [data, setData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [searchValue, setSearchValue] = useState(q);
  const [reloadKey, setReloadKey] = useState(0);
  const { page, offset, pageSize, setPage } = useUrlPagination(PAGE_SIZE);

  // Черновик в поле поиска следует за URL (назад/вперёд в браузере)
  useEffect(() => {
    setSearchValue(q);
  }, [q]);

  useEffect(() => {
    let cancelled = false;
    const request = q
      ? apiRequests.portfolio.getIndustriesFiltered(q, pageSize, offset)
      : apiRequests.portfolio.getIndustries(pageSize, offset);
    request
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((e) => console.error(e));
    return () => {
      cancelled = true;
    };
  }, [q, offset, pageSize, reloadKey]);

  const handleSearch = () => {
    const next = searchValue.trim();
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (next) params.set('q', next);
      else params.delete('q');
      params.delete('page');
      return params;
    });
  };

  const handleDelete = (id) => {
    apiRequests.portfolio.deleteIndustry(id).then(() => {
      if (data.items?.length === 1 && page > 1) setPage(page - 1);
      else setReloadKey((k) => k + 1);
    });
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск индустрий..."
        createLink="/portfolio/industries/create"
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          q ? (
            <EmptyState
              icon={Factory}
              variant="search"
              title="Индустрия не найдена"
              description={`По запросу «${q}» индустрий нет. Возможно, её стоит создать — она сразу появится в фильтрах портфолио.`}
            />
          ) : (
            <EmptyState
              icon={Factory}
              title="Индустрий пока нет"
              description="Индустрии помогают посетителям находить кейсы из своей сферы — например, «Финтех» или «Медицина»."
              action={{
                label: 'Добавить индустрию',
                to: '/portfolio/industries/create',
                icon: Plus,
              }}
            />
          )
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[{ label: 'Создано', value: dateToString(item.createdAt) }]}
              editLink={`/portfolio/industries/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination page={page} total={data.totalCount} pageSize={pageSize} onPageChange={setPage} />
    </>
  );
};

export default IndustriesPage;
